module.exports = __webpack_public_path__ + "img/review-4.f29bcc67.png";